export const creditCardBrands: any = {
  amex: 'AMEX',
  discover: 'Discover',
  master_card: 'Mastercard',
  visa: 'VISA',
};
